/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UnmigratedUserType {
  CastingProfessional = "CastingProfessional",
  Performer = "Performer",
  YoungPerformer = "YoungPerformer",
  Graduate = "Graduate",
}

export enum UnmigratedAccountOrderBy {
  Name = "Name",
  CreatedAt = "CreatedAt",
  MigratedAt = "MigratedAt",
}

export enum TemporalUnit {
  Undefined = "Undefined",
  Day = "Day",
  Month = "Month",
  Week = "Week",
  Year = "Year",
}

export enum SubscriptionState {
  Current = "Current",
  Renewing = "Renewing",
  Expired = "Expired",
}

export enum SubscriptionChangeType {
  Upgrade = "Upgrade",
  Downgrade = "Downgrade",
  ChangePlan = "ChangePlan",
  ReinstatePlan = "ReinstatePlan",
}

export enum SortOrder {
  Asc = "Asc",
  Desc = "Desc",
}

export enum RedemptionResource {
  Undefined = "Undefined",
  Account = "Account",
  Subscription = "Subscription",
}

export enum PlanRequestType {
  All = "All",
  Classic = "Classic",
  Premium = "Premium",
  Downgrade = "Downgrade",
  Upgrade = "Upgrade",
}

export enum MigratedState {
  Migrated = "Migrated",
  Unmigrated = "Unmigrated",
}

export enum FreeTrialUnit {
  Undefined = "Undefined",
  Day = "Day",
  Month = "Month",
  Week = "Week",
}

export enum DiscountType {
  Undefined = "Undefined",
  Fixed = "Fixed",
  FreeTrial = "FreeTrial",
  Percent = "Percent",
}

export enum CouponType {
  Undefined = "Undefined",
  Bulk = "Bulk",
  SingleCode = "SingleCode",
}

export enum CouponState {
  Undefined = "Undefined",
  Expired = "Expired",
  MaxedOut = "MaxedOut",
  Redeemable = "Redeemable",
}

export enum CouponDuration {
  Undefined = "Undefined",
  Forever = "Forever",
  SingleUse = "SingleUse",
  Temporal = "Temporal",
}

export enum CastingOrg {
  BBC = "BBC",
  ITV = "ITV",
}

export enum ActiveState {
  Undefined = "Undefined",
  Active = "Active",
  Inactive = "Inactive",
}

export interface AccountDetailsDto {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  discounts?: CouponDto[] | null;
  code?: string | null;
  id?: string | null;
  url?: string | null;
  /** @format uuid */
  portalId?: string | null;
  isUkPerformer?: boolean;
  parentAccountId?: string | null;
  isEligibleForGradTransfer?: boolean;
  isEligibleToChangePlan?: boolean;
}

export interface AccountDetailsResponseDto {
  account?: AccountDetailsDto;
  subscription?: SubscriptionDto;
  address?: AddressDto;
  addOns?: AddOnDtoStatus[] | null;
}

export interface AccountDto {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  discounts?: CouponDto[] | null;
}

export interface AccountRecord {
  email?: string | null;
  originalViewPin?: string | null;
  viewPin?: string | null;
  profileId?: string | null;
}

export interface AccountRecordEntitlements {
  email?: string | null;
  originalViewPin?: string | null;
  viewPin?: string | null;
  entitlements?: string[] | null;
}

export interface AccountsDetailsResponseDto {
  accounts?: AccountDetailsResponseDto[] | null;
}

export interface ActivePaymentMethodResponse {
  cardNumber?: string | null;
  bankAccountNumber?: string | null;
  address?: string | null;
  accountHolderName?: string | null;
  cardType?: string | null;
  paymentMethodType?: string | null;
  isValid?: boolean;
}

export interface AddOnDto {
  name?: string | null;
  code?: string | null;
  /** @format double */
  taxPercentage?: number;
  /** @format double */
  amountValue?: number | null;
  amount?: string | null;
  /** @format double */
  totalValue?: number | null;
  total?: string | null;
  /** @format double */
  proRataValue?: number | null;
  proRata?: string | null;
  currency?: string | null;
}

export interface AddOnDtoStatus {
  name?: string | null;
  code?: string | null;
  calculatedStatus?: string | null;
  description?: string | null;
  url?: string | null;
  availableToBuy?: boolean;
  cancelled?: boolean;
}

export interface AddOnMiniDto {
  id?: string | null;
  code?: string | null;
  name?: string | null;
}

export interface AddressDto {
  city?: string | null;
  country?: string | null;
  phone?: string | null;
  region?: string | null;
  street1?: string | null;
  street2?: string | null;
  postal_code?: string | null;
}

export interface AgentRequest {
  artistRef?: string | null;
  /** @format uuid */
  portalGuid?: string;
  /** @format int32 */
  publicationCode?: number;
}

export interface AuditEvent {
  objectType?: string | null;
  objectId?: string | null;
  action?: string | null;
  source?: string | null;
  description?: string | null;
  /** @format date-time */
  created?: string;
}

export interface AuditEventsResponseDto {
  artistRef?: string | null;
  auditEvents?: AuditEvent[] | null;
}

export interface CancelAddOnRequest {
  subscriptionId?: string | null;
  addOns?: string[] | null;
}

export interface CheckoutTypeResponse {
  checkoutType?: string | null;
}

export interface Coupon {
  appliesToAllItems?: boolean | null;
  appliesToAllPlans?: boolean | null;
  appliesToNonPlanCharges?: boolean | null;
  code?: string | null;
  couponType?: CouponType;
  /** @format date-time */
  createdAt?: string | null;
  discount?: CouponDiscount;
  duration?: CouponDuration;
  /** @format date-time */
  expiredAt?: string | null;
  /** @format int32 */
  freeTrialAmount?: number | null;
  freeTrialUnit?: FreeTrialUnit;
  hostedPageDescription?: string | null;
  id?: string | null;
  invoiceDescription?: string | null;
  items?: ItemMini[] | null;
  /** @format int32 */
  maxRedemptions?: number | null;
  /** @format int32 */
  maxRedemptionsPerAccount?: number | null;
  name?: string | null;
  object?: string | null;
  plans?: PlanMini[] | null;
  /** @format date-time */
  redeemBy?: string | null;
  redemptionResource?: RedemptionResource;
  state?: CouponState;
  /** @format int32 */
  temporalAmount?: number | null;
  temporalUnit?: TemporalUnit;
  uniqueCodeTemplate?: string | null;
  uniqueCouponCode?: Record<string, string | null>;
  /** @format int32 */
  uniqueCouponCodesCount?: number | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface CouponDiscount {
  currencies?: CouponDiscountPricing[] | null;
  /** @format int32 */
  percent?: number | null;
  trial?: CouponDiscountTrial;
  type?: DiscountType;
}

export interface CouponDiscountPricing {
  /** @format double */
  amount?: number | null;
  currency?: string | null;
}

export interface CouponDiscountTrial {
  /** @format int32 */
  length?: number | null;
  unit?: FreeTrialUnit;
}

export interface CouponDto {
  code: string | null;
  name: string | null;
  description: string | null;
  /** @format int32 */
  discountPercent: number;
  isRemovable: boolean;
}

export interface CreateAccountRequest {
  email?: string | null;
  forename?: string | null;
  surname?: string | null;
  parentName?: string | null;
  previousEmail?: string | null;
  previousName?: string | null;
  address?: UpdateAccountAddressRequest;
}

export interface CreateAccountResponse {
  accountId?: string | null;
}

export interface CreateBillingInfoRequest {
  token?: string | null;
  threeDsToken?: string | null;
}

export interface CreateBillingInfoResponse {
  billingInfoId?: string | null;
  threeDSActionRequired?: boolean;
  tokenId?: string | null;
  accountId?: string | null;
  actionTokenId?: string | null;
}

export interface CreateGradAccountRequest {
  /** @format int32 */
  onlineApplicationId?: number;
  securityKey?: string | null;
  email?: string | null;
  forename?: string | null;
  surname?: string | null;
  previousName?: string | null;
  previousEmail?: string | null;
  currency?: string | null;
  address?: UpdateAccountAddressRequest;
}

export interface CreateNewCastingOrgUserRequest {
  email?: string | null;
  forename?: string | null;
  surname?: string | null;
  /** @format uuid */
  portalId?: string | null;
  castingOrganisation?: CastingOrg;
}

export interface CreateNewCastingOrgUserResponse {
  accountId?: string | null;
}

export interface CreatePurchasePreviewRequest {
  token?: string | null;
  planId?: string | null;
  couponCodes?: string[] | null;
  threeDsToken?: string | null;
  addOns?: string[] | null;
  countryCode?: string | null;
}

export interface CreatePurchaseRequest {
  token?: string | null;
  planId?: string | null;
  couponCodes?: string[] | null;
  threeDsToken?: string | null;
  addOns?: string[] | null;
}

export interface CreatePurchaseResponse {
  threeDSActionRequired?: boolean;
  tokenId?: string | null;
  accountId?: string | null;
  actionTokenId?: string | null;
}

export interface CreateSubscriptionRequest {
  planId?: string | null;
  couponCode?: string | null;
  currency?: string | null;
  /** @format uuid */
  portalId?: string;
  isCastingOrgMember?: boolean | null;
  addOns?: string[] | null;
}

export interface CreateSubscriptionResponse {
  success?: boolean;
  subscriptionId?: string | null;
}

export interface EligibleActionsResponseDto {
  isEligibleForGradTransfer?: boolean;
  isEligibleToChangePlan?: boolean;
  isEligibleToCancel?: boolean;
  isEligibleToReinstate?: boolean;
  isEligibleToRenew?: boolean;
  isEligibleToReactivate?: boolean;
}

export interface GetPlanAddOnListResponse {
  addOns?: AddOnMiniDto[] | null;
  planId?: string | null;
}

export interface GetPlansResponse {
  plans?: PlanMiniDto[] | null;
}

export interface GetUnmigratedAccountRequest {
  /** @format uuid */
  crmContactGuid?: string | null;
  nameFilter?: string | null;
  emailFilter?: string | null;
  userTypeFilter?: UnmigratedUserType[] | null;
  migratedStateFilter?: MigratedState[] | null;
  orderBy?: UnmigratedAccountOrderBy;
  sortOrder?: SortOrder;
}

export interface InternalCreateAccountRequest {
  forename?: string | null;
  surname?: string | null;
  email?: string | null;
  username?: string | null;
  artistRef?: string | null;
  /** @format uuid */
  portalId?: string;
}

export interface InternalCreateSubscriptionRequest {
  accountCode?: string | null;
  planCode?: string | null;
  currency?: string | null;
}

export interface ItemMini {
  code?: string | null;
  description?: string | null;
  id?: string | null;
  name?: string | null;
  object?: string | null;
  state?: ActiveState;
}

export interface ListEntitlementsRequest {
  accounts?: AccountRecord[] | null;
}

export interface ListEntitlementsResponse {
  accounts?: AccountRecordEntitlements[] | null;
}

export interface MigrateAccountRequest {
  /** @format uuid */
  crmContactGuid?: string;
}

export interface MigrateAccountResponse {
  success?: boolean;
  error?: string | null;
}

export interface PendingSubscription {
  planCode?: string | null;
  addOns?: string[] | null;
}

export interface PlanDto {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  code?: string | null;
  /** @format double */
  taxPercentage?: number;
  /** @format double */
  amountValue?: number;
  amount?: string | null;
  /** @format double */
  totalValue?: number | null;
  total?: string | null;
  currencySymbol?: string | null;
  addOns?: AddOnDto[] | null;
  planType?: string | null;
  currency?: string | null;
  autoRenewEnabled?: boolean;
}

export interface PlanMini {
  code?: string | null;
  id?: string | null;
  name?: string | null;
  object?: string | null;
}

export interface PlanMiniDto {
  id?: string | null;
  code?: string | null;
  name?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface PurchasePreviewResponse {
  subtotal?: string | null;
  tax?: string | null;
  discount?: string | null;
  total?: string | null;
  amount?: string | null;
  /** @format double */
  taxPercentage?: number | null;
  isFreeTrial?: boolean;
  freeTrialDescription?: string | null;
  automaticCouponDescriptions?: string[] | null;
  accountCredited?: string | null;
  addOns?: AddOnDto[] | null;
  /** @format date-time */
  nextBillingDate?: string | null;
}

export interface SetSubscriptionStateRequest {
  subscriptionId?: string | null;
  state?: SubscriptionState;
}

export interface SubscriptionChangePreviewResponse {
  subtotal?: string | null;
  tax?: string | null;
  discount?: string | null;
  total?: string | null;
  amount?: string | null;
  /** @format double */
  taxPercentage?: number | null;
  isFreeTrial?: boolean;
  freeTrialDescription?: string | null;
  automaticCouponDescriptions?: string[] | null;
  addOns?: AddOnDto[] | null;
  /** @format date-time */
  nextBillingDate?: string | null;
  creditApplied?: string | null;
  accountCredited?: string | null;
}

export interface SubscriptionChangeRequest {
  planId?: string | null;
  couponCodes?: string[] | null;
  changeType?: SubscriptionChangeType;
  accountId?: string | null;
}

export interface SubscriptionDto {
  /** @format date-time */
  currentTermStartedAt?: string;
  /** @format date-time */
  currentTermEndsAt?: string;
  /** @format date-time */
  expiresAt?: string | null;
  state?: string | null;
  plan?: string | null;
  planCode?: string | null;
  calculatedStatus?: string | null;
  id?: string | null;
  pendingSubscription?: PendingSubscription;
}

export interface TransferGraduateRequest {
  accountId?: string | null;
  planId?: string | null;
  /** @format uuid */
  portalId?: string;
  currency?: string | null;
  couponCode?: string | null;
  addOns?: string[] | null;
  billingInfoId?: string | null;
}

export interface UnmigratedAccountDto {
  crmContactId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  mobilePhone?: string | null;
  company?: string | null;
  allowDirectDebit?: boolean;
  disableOnlineReactivate?: boolean;
  renewMembership?: boolean;
  hasAgent?: boolean | null;
  membershipGroupName?: string | null;
  discount?: string | null;
  postcode?: string | null;
  parentName?: string | null;
  accountingRef?: string | null;
  accountId?: string | null;
  email?: string | null;
  hasAccountInRecurly?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  migratedAt?: string | null;
  /** @format date-time */
  nameHeldUntil?: string | null;
}

export interface UnmigratedAccountsResponse {
  accounts?: UnmigratedAccountDto[] | null;
  /** @format int32 */
  count?: number;
}

export interface UpdateAccountAddressRequest {
  street1?: string | null;
  street2?: string | null;
  city?: string | null;
  postal_code?: string | null;
  country?: string | null;
  stateProvince?: string | null;
  phone?: string | null;
}

export interface UpdateAccountCpaOptInRequest {
  acceptedCPA?: boolean | null;
}

export interface UpdateAccountRenewalRequest {
  reactivateSubscription?: boolean;
  renewSubscription?: boolean;
}

export interface UpdateAccountRenewalResponse {
  success?: boolean;
}

export interface UpdateAccountRequest {
  /** @format uuid */
  portalId?: string;
  artistRef?: string | null;
  forename?: string | null;
  surname?: string | null;
  email?: string | null;
  mobilePhone?: string | null;
}

export interface UpdateAccountResponse {
  success?: boolean;
}

export interface UpdateCastingAccountRequest {
  /** @format uuid */
  applicationId?: string;
  securityKey?: string | null;
  companyName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  accountId?: string | null;
  mobile?: string | null;
  /** @format uuid */
  portalId?: string | null;
}

export interface UpdateUnmigratedAccountRequest {
  /** @minLength 1 */
  crmContactId: string;
  /** @format date-time */
  nameHeldUntil?: string | null;
  disableOnlineReactivate?: boolean | null;
  allowDirectDebit?: boolean | null;
  renewMembership?: boolean | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Billing API
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  account = {
    /**
     * No description
     *
     * @tags Account
     * @name AccountList
     * @request GET:/account
     * @secure
     */
    accountList: <TResponse = AccountDto, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name DetailsList
     * @request GET:/account/details
     * @secure
     */
    detailsList: <TResponse = AccountDetailsResponseDto, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/details`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AddressUpdate
     * @request PUT:/account/address
     * @secure
     */
    addressUpdate: <TResponse = unknown, TError = any>(
      data: UpdateAccountAddressRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/address`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccessList
     * @request GET:/account/access
     * @secure
     */
    accessList: <TResponse = CheckoutTypeResponse, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/access`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SummaryList
     * @request GET:/account/summary
     * @secure
     */
    summaryList: <TResponse = AccountDto, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name DetailsDetail
     * @request GET:/account/details/{accountId}
     */
    detailsDetail: <TResponse = AccountDetailsResponseDto, TError = any>(
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/details/${accountId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name BulkDetailsList
     * @request GET:/account/bulk-details
     */
    bulkDetailsList: <TResponse = AccountsDetailsResponseDto, TError = any>(
      query?: {
        accountIdsCsv?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/bulk-details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name StatusDetail
     * @request GET:/account/status/{artistRef}
     */
    statusDetail: <TResponse = unknown, TError = any>(
      artistRef: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/status/${artistRef}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name RefreshCreate
     * @request POST:/account/refresh/{accountId}
     */
    refreshCreate: <TResponse = unknown, TError = any>(
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/refresh/${accountId}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name BulkRefreshCreate
     * @request POST:/account/bulk-refresh
     */
    bulkRefreshCreate: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/bulk-refresh`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name BillingList
     * @request GET:/account/{accountId}/billing
     * @secure
     */
    billingList: <TResponse = unknown, TError = any>(
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/${accountId}/billing`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AddressList
     * @request GET:/account/{accountId}/address
     * @secure
     */
    addressList: <TResponse = AddressDto, TError = any>(
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/${accountId}/address`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CreateCreate
     * @request POST:/account/create
     * @secure
     */
    createCreate: <TResponse = CreateAccountResponse, TError = any>(
      data: CreateAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CreateGraduateCreate
     * @request POST:/account/create/graduate
     * @secure
     */
    createGraduateCreate: <TResponse = CreateAccountResponse, TError = any>(
      data: CreateGradAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/create/graduate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name BillingCreate
     * @request POST:/account/billing/{accountId}
     * @secure
     */
    billingCreate: <TResponse = CreateBillingInfoResponse, TError = any>(
      accountId: string,
      data: CreateBillingInfoRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/billing/${accountId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name BillingInfoCreate
     * @request POST:/account/billing-info
     * @secure
     */
    billingInfoCreate: <TResponse = CreateBillingInfoResponse, TError = any>(
      data: CreateBillingInfoRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/billing-info`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountUpdate
     * @request PUT:/account/{accountId}
     */
    accountUpdate: <TResponse = UpdateAccountResponse, TError = any>(
      accountId: string,
      data: UpdateAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/${accountId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CastingUpdate
     * @request PUT:/account/casting/{accountId}
     * @secure
     */
    castingUpdate: <TResponse = unknown, TError = any>(
      accountId: string,
      data: UpdateCastingAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/casting/${accountId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name RenewalUpdate
     * @request PUT:/account/renewal/{accountId}
     */
    renewalUpdate: <TResponse = UpdateAccountRenewalResponse, TError = any>(
      accountId: string,
      data: UpdateAccountRenewalRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/renewal/${accountId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ActivepaymentmethodList
     * @request GET:/account/activepaymentmethod
     * @secure
     */
    activepaymentmethodList: <
      TResponse = ActivePaymentMethodResponse,
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/activepaymentmethod`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CastingCloseDelete
     * @request DELETE:/account/casting/close/{accountId}
     */
    castingCloseDelete: <TResponse = unknown, TError = any>(
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/casting/close/${accountId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CastingCastingorgdetailsList
     * @request GET:/account/casting/castingorgdetails
     */
    castingCastingorgdetailsList: <
      TResponse = AccountsDetailsResponseDto,
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/casting/castingorgdetails`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CastingNewcastingorguserCreate
     * @request POST:/account/casting/newcastingorguser
     */
    castingNewcastingorguserCreate: <
      TResponse = CreateNewCastingOrgUserResponse,
      TError = any,
    >(
      data: CreateNewCastingOrgUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/casting/newcastingorguser`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CpaOptInUpdate
     * @request PUT:/account/cpaOptIn
     * @secure
     */
    cpaOptInUpdate: <TResponse = unknown, TError = any>(
      data: UpdateAccountCpaOptInRequest,
      query?: {
        accountId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/account/cpaOptIn`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  addons = {
    /**
     * No description
     *
     * @tags AddOn
     * @name EcpPreviewList
     * @request GET:/addons/ecp/preview
     */
    ecpPreviewList: <TResponse = AddOnDto[], TError = ProblemDetails>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/addons/ecp/preview`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddOn
     * @name PreviewList
     * @request GET:/addons/{addonCode}/preview
     */
    previewList: <TResponse = AddOnDto[], TError = ProblemDetails>(
      addOnCode: string,
      addonCode: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/addons/${addonCode}/preview`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddOn
     * @name PreviewCreate
     * @request POST:/addons/preview
     */
    previewCreate: <TResponse = PurchasePreviewResponse, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/addons/preview`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddOn
     * @name PurchaseCreate
     * @request POST:/addons/purchase
     */
    purchaseCreate: <TResponse = unknown, TError = any>(
      data: CreatePurchaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/addons/purchase`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddOn
     * @name CancelCreate
     * @request POST:/addons/cancel
     */
    cancelCreate: <TResponse = unknown, TError = any>(
      data: CancelAddOnRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/addons/cancel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  audit = {
    /**
     * No description
     *
     * @tags Audit
     * @name EventsList
     * @request GET:/audit/{artistRef}/events
     */
    eventsList: <TResponse = AuditEventsResponseDto, TError = unknown>(
      artistRef: string,
      query?: {
        /** @format date-time */
        fromDate?: string;
        /** @format date-time */
        toDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/audit/${artistRef}/events`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  checkout = {
    /**
     * No description
     *
     * @tags Checkout
     * @name PurchaseCreate
     * @request POST:/checkout/purchase
     * @secure
     */
    purchaseCreate: <TResponse = CreatePurchaseResponse, TError = any>(
      data: CreatePurchaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/checkout/purchase`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout
     * @name SubscribeCreate
     * @request POST:/checkout/subscribe
     * @secure
     */
    subscribeCreate: <TResponse = CreateSubscriptionResponse, TError = any>(
      data: CreateSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/checkout/subscribe`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout
     * @name PreviewCreate
     * @request POST:/checkout/preview
     * @secure
     */
    previewCreate: <TResponse = PurchasePreviewResponse, TError = any>(
      data: CreatePurchasePreviewRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/checkout/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  joining = {
    /**
     * No description
     *
     * @tags Checkout
     * @name PreviewCreate
     * @request POST:/joining/preview
     * @secure
     */
    previewCreate: <TResponse = PurchasePreviewResponse, TError = any>(
      data: CreatePurchasePreviewRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/joining/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  coupons = {
    /**
     * No description
     *
     * @tags Coupons
     * @name CouponsDetail
     * @request GET:/coupons/{couponId}
     * @secure
     */
    couponsDetail: <TResponse = Coupon, TError = ProblemDetails>(
      couponId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/coupons/${couponId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupons
     * @name ApplyFmCreate
     * @request POST:/coupons/apply/fm
     * @secure
     */
    applyFmCreate: <TResponse = unknown, TError = unknown>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/coupons/apply/fm`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  internal = {
    /**
     * No description
     *
     * @tags Internal
     * @name AccountCreate
     * @request POST:/internal/account
     */
    accountCreate: <TResponse = unknown, TError = any>(
      data: InternalCreateAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/internal/account`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name SubscriptionCreate
     * @request POST:/internal/subscription
     */
    subscriptionCreate: <TResponse = unknown, TError = any>(
      data: InternalCreateSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/internal/subscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name StateCreate
     * @request POST:/internal/state
     */
    stateCreate: <TResponse = unknown, TError = any>(
      data: SetSubscriptionStateRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/internal/state`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name PlansList
     * @request GET:/internal/plans
     */
    plansList: <TResponse = GetPlansResponse, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/internal/plans`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name PlansAddonList
     * @request GET:/internal/plans/{planId}/addon
     */
    plansAddonList: <TResponse = GetPlanAddOnListResponse, TError = any>(
      planId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/internal/plans/${planId}/addon`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name EntitlementsCreate
     * @request POST:/internal/entitlements
     */
    entitlementsCreate: <TResponse = ListEntitlementsResponse, TError = any>(
      data: ListEntitlementsRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/internal/entitlements`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  plans = {
    /**
     * No description
     *
     * @tags Plans
     * @name RenewalList
     * @request GET:/plans/renewal
     * @secure
     */
    renewalList: <TResponse = PlanDto[], TError = ProblemDetails>(
      query?: {
        planType?: PlanRequestType;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/plans/renewal`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name JoiningList
     * @request GET:/plans/joining
     * @secure
     */
    joiningList: <TResponse = PlanDto[], TError = any>(
      query?: {
        type?: string;
        accountId?: string;
        planType?: PlanRequestType;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/plans/joining`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name TransferList
     * @request GET:/plans/transfer
     * @secure
     */
    transferList: <TResponse = PlanDto[], TError = any>(
      query?: {
        accountId?: string;
        planType?: PlanRequestType;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/plans/transfer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  subscription = {
    /**
     * No description
     *
     * @tags Subscription
     * @name CancelCreate
     * @request POST:/subscription/cancel
     * @secure
     */
    cancelCreate: <TResponse = unknown, TError = unknown>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/cancel`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ReactivateCreate
     * @request POST:/subscription/reactivate
     * @secure
     */
    reactivateCreate: <TResponse = unknown, TError = unknown>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/reactivate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name PreviewCreate
     * @request POST:/subscription/preview
     * @secure
     */
    previewCreate: <
      TResponse = SubscriptionChangePreviewResponse,
      TError = unknown,
    >(
      data: SubscriptionChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name UpgradeCreate
     * @request POST:/subscription/upgrade
     * @secure
     */
    upgradeCreate: <TResponse = unknown, TError = unknown>(
      data: SubscriptionChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/upgrade`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name DowngradeCreate
     * @request POST:/subscription/downgrade
     * @secure
     */
    downgradeCreate: <TResponse = unknown, TError = unknown>(
      data: SubscriptionChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/downgrade`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ChangePlanCreate
     * @request POST:/subscription/change-plan
     * @secure
     */
    changePlanCreate: <TResponse = unknown, TError = unknown>(
      data: SubscriptionChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/change-plan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ReinstatePlanCreate
     * @request POST:/subscription/reinstate-plan
     * @secure
     */
    reinstatePlanCreate: <TResponse = unknown, TError = unknown>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/reinstate-plan`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name StartdateList
     * @request GET:/subscription/{accountId}/startdate
     * @secure
     */
    startdateList: <TResponse = string, TError = any>(
      accountId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/${accountId}/startdate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name TransferGraduateCreate
     * @request POST:/subscription/transfer-graduate
     */
    transferGraduateCreate: <TResponse = unknown, TError = any>(
      data: TransferGraduateRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/transfer-graduate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name CreatecastingorgusersubscriptionCreate
     * @request POST:/subscription/createcastingorgusersubscription/{accountId}
     */
    createcastingorgusersubscriptionCreate: <
      TResponse = CreateSubscriptionResponse,
      TError = any,
    >(
      accountId: string,
      data: CreateSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/createcastingorgusersubscription/${accountId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ActionsList
     * @request GET:/subscription/actions
     * @secure
     */
    actionsList: <TResponse = EligibleActionsResponseDto, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/subscription/actions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  unmigratedcrmaccounts = {
    /**
     * No description
     *
     * @tags UnmigratedAccounts
     * @name UnmigratedcrmaccountsCreate
     * @request POST:/unmigratedcrmaccounts
     */
    unmigratedcrmaccountsCreate: <
      TResponse = UnmigratedAccountsResponse,
      TError = any,
    >(
      data: GetUnmigratedAccountRequest,
      query?: {
        /** @format int32 */
        pageNumber?: number;
        /** @format int32 */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/unmigratedcrmaccounts`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UnmigratedAccounts
     * @name UpdateCreate
     * @request POST:/unmigratedcrmaccounts/update
     */
    updateCreate: <TResponse = UnmigratedAccountDto, TError = string>(
      data: UpdateUnmigratedAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/unmigratedcrmaccounts/update`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UnmigratedAccounts
     * @name MigrateCreate
     * @request POST:/unmigratedcrmaccounts/migrate
     */
    migrateCreate: <TResponse = MigrateAccountResponse, TError = any>(
      data: MigrateAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/unmigratedcrmaccounts/migrate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  yp = {
    /**
     * No description
     *
     * @tags YoungPerformer
     * @name NoagentCreate
     * @request POST:/yp/noagent
     */
    noagentCreate: <TResponse = unknown, TError = any>(
      data: AgentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/yp/noagent`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags YoungPerformer
     * @name AgentsCreate
     * @request POST:/yp/agents
     */
    agentsCreate: <TResponse = unknown, TError = any>(
      data: AgentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/yp/agents`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
}
